/* eslint-disable complexity */
import { formatDateSaveDB } from "../../../../../../../../utils/getDate"
import { getTextByKey } from "../../../../../../../../utils/getTextByKey"
import { getValueCombobox } from "../../../../../../../../utils/getValueCombobox"
import { GetScheduleInfoAddProps } from "../../../../../models/add"
import { ScheduleInfoAddType } from "../../../../../models/add/DataAdd"

export const getScheduleInfoAdd = (
  data: GetScheduleInfoAddProps,
): ScheduleInfoAddType => {
  const {
    dataSubmit,
    departments,
    isOtherStaffNumber,
    purposeTravelList,
    travelerBase,
    travelerDetail,
    travelerId,
  } = data
  const bumonName = getTextByKey(dataSubmit.bumonCd, departments)
  const travelPurposeName = getTextByKey(
    dataSubmit.travelPurposeId,
    purposeTravelList,
  )

  const getValue = (value: string) => (isOtherStaffNumber ? "" : value)

  return {
    bumonCd: getValueCombobox(dataSubmit.bumonCd, bumonName),
    codeConductConfirmation: dataSubmit.codeConductConfirmation,
    detailSortType: dataSubmit.detailSortType,
    differentInforCheck: !!dataSubmit.differentInforCheck,
    dispatchEndDate: formatDateSaveDB(dataSubmit.dispatchEndDate, true),
    dispatchStartDate: formatDateSaveDB(dataSubmit.dispatchStartDate),
    dispatchTypeDetailId: "",
    hakenIdentityNumber: "",
    insuranceCompanyName: dataSubmit.insuranceCompanyName,
    insuranceCompanyPhoneNumber: dataSubmit.insuranceCompanyPhoneNumber,
    insuranceSonsignor: dataSubmit.insuranceSonsignor,
    insuranceTicketNumber: dataSubmit.insuranceTicketNumber,
    kanjiName: travelerBase?.kanjiName || "",
    kanjiSurname: travelerBase?.kanjiSurname || "",
    locationPersonName: dataSubmit.locationPersonName,
    mainPersonName: dataSubmit.mainPersonName,
    managerRemarks1: dataSubmit.managerRemarks1,
    managerRemarks2: dataSubmit.managerRemarks2,
    managerRemarks3: dataSubmit.managerRemarks3,
    managerRemarks4: dataSubmit.managerRemarks4,
    managerRemarks5: dataSubmit.managerRemarks5,
    procurementControlNumber: dataSubmit.procurementControlNumber,
    projectNameEn: dataSubmit.projectNameEn,
    projectNameJp: dataSubmit.projectNameJp,
    romajiName: travelerBase?.romajiName || "",
    romajiSurname: travelerBase?.romajiSurname || "",
    travelPurposeId: getValueCombobox(
      dataSubmit.travelPurposeId,
      travelPurposeName,
    ),
    travelerBumonCd: getValue(dataSubmit.travelerBumonCd),
    travelerDispatchTypeDetailId: getValue(
      dataSubmit.travelerDispatchTypeDetailId,
    ),
    travelerId,
    urgentAffiliationContact: travelerDetail?.urgentAffiliationContact || "",
    urgentAffiliationContactName:
      travelerDetail?.urgentAffiliationContactName || "",
    urgentContactHome: travelerDetail?.urgentContactHome || "",
    urgentContactName: travelerDetail?.urgentContactName || "",
    volunteerIdentityNumber: "",
    workPlaceCountryCode: "",
    zaigaiIdentityNumber: "",
  }
}
